import React from 'react';
import cx from 'classnames';
import ResultsTopBar from 'root/components/ResultsTopBar';
import NoResults from '../NoResults';
import VirtualResultsGrid from './VirtualResultsGrid/VirtualResultsGrid';

const ResultImageGrid = (props) => {
  const renderGridContent = () =>
    props.images?.length || props.showProgressIndicator ? (
      <VirtualResultsGrid
        images={props.images}
        selected={props.selected}
        selectionAction={props.selectionAction}
        onLoadMore={props.onLoadMore}
        useImageClientSize={props.useImageClientSize}
        isMultiple={props.isMultiple}
        allowSelect={props.allowSelect}
        customPreviewInfo={props.customTilePreviewInfo}
        alwaysShowPreviewInfo={props.alwaysShowPreviewInfo}
        hasMore={props.hasMore}
        itemWidth={props.itemWidth}
        isLoading={props.showProgressIndicator}
      />
    ) : (
      !props.showProgressIndicator && <NoResults key="ig_no_results" />
    );

  const topBarRenderResult = props.topBarRenderer?.();

  return (
    <div className="relative flex flex-column justify-center h-100" data-test="grid-container">
      {topBarRenderResult && (
        <ResultsTopBar>
          <div className={`pa5 ${props.topBarClassName || ''}`} data-test="grid-top-bar">
            {topBarRenderResult}
          </div>
        </ResultsTopBar>
      )}

      <div className={cx('grid flex-grow-1', { empty: props.images.length })}>{renderGridContent()}</div>
    </div>
  );
};

ResultImageGrid.defaultProps = {
  allowSelect: true,
  showProgressIndicator: false,
  useImageClientSize: false,
};

export default ResultImageGrid;
